export default {
  beforeMount(el, binding) {
    if (binding.value) {
      binding.value();
    }
  },
};
